module.exports = __webpack_public_path__ + "static/media/reference-slider-11.30412460.jpg";